import { render, staticRenderFns } from "./HeroFooter.vue?vue&type=template&id=682de0be&scoped=true&"
import script from "./HeroFooter.vue?vue&type=script&lang=js&"
export * from "./HeroFooter.vue?vue&type=script&lang=js&"
import style0 from "./HeroFooter.vue?vue&type=style&index=0&id=682de0be&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "682de0be",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ContributorSignUpLink: require('/opt/render/project/src/channels2022/src/components/contributor/signup/ContributorSignUpLink.vue').default})
